// extracted by mini-css-extract-plugin
module.exports = {"message":"ErrorMessage_message__2zhSu","error_message":"ErrorMessage_error_message__8T8hm","name_error":"ErrorMessage_name_error__2bmxg"};